import { Breadcrumb, Text } from "@chakra-ui/react";
import { Fragment } from "react/jsx-runtime";
import { v4 } from "uuid";

interface Props {
  options: {
    label: string;
    href: string;
    strong?: boolean;
  }[];
}

export const BreadcrumbComponent = ({ options }: Props) => {
  return (
    <Breadcrumb.Root>
      <Breadcrumb.List>
        {options.map((option, index) => (
          <Fragment key={v4()}>
            <Breadcrumb.Item key={v4()}>
              <Breadcrumb.Link href={option.href}>
                <Text fontWeight={option.strong ? 600 : 400} fontSize="14px">
                  {option.label}
                </Text>
              </Breadcrumb.Link>
            </Breadcrumb.Item>
            {index < options.length - 1 && <Breadcrumb.Separator />}
          </Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  );
};
